'use client'

import { useGoogleLogin } from '@/lib/api/hooks/use-account'
import { Button, Spin } from 'antd'
import React from 'react'
import { AiOutlineGoogle } from 'react-icons/ai'

export default function ThirdPartyLogin() {
  const { mutateAsync: googleLogin, isPending } = useGoogleLogin()

  const spinning = isPending

  const onGoogleLogin = async () => {
    await googleLogin({
      redirectUrl: `${window.location.origin}/api/auth`,
    })
  }

  return (
    <>
      <div className='flex items-center justify-center'>
        <Button
          shape='circle'
          icon={<AiOutlineGoogle className='text-2xl text-white' />}
          className='h-[52px] w-[52px] bg-[#7A828A] hover:bg-[#FF3C8E]'
          onClick={onGoogleLogin}
        />
      </div>
      <Spin spinning={spinning} fullscreen={true} />
    </>
  )
}
